import { createSlice, PayloadAction  } from "@reduxjs/toolkit";

export interface SettingModel{
    error:string;
    countryDialingList:any[];
    categoryList:any[];
}

const initialState:SettingModel = {
    error: "",
    countryDialingList: [],
    categoryList: []
}

const SettingSlice = createSlice({
    name: "SettingSlice",
    initialState,
    reducers: {
        setCountryDialingList(state: any, action: PayloadAction<{ countryDialingList?: any }>) {
            state.countryDialingList = action.payload.countryDialingList;
        },
        setCategoryList(state: any, action: PayloadAction<{ categoryList?: any }>) {
            state.categoryList = action.payload.categoryList;
        }
    }
});
export const selectCountryList = (state: any) => state.SettingSlice?.countryList || [];
export const { setCountryDialingList, setCategoryList } = SettingSlice.actions;
export default SettingSlice;